import * as actionTypes from './ActionTypes';

export const getListOfVideoMainTopics = (
  videosTopicRequestBody,
  openSnackbar = () => {
  },
) => {
  return {
    type: actionTypes.GET_VIDEO_MAIN_TOPICS,
    videosTopicRequestBody: videosTopicRequestBody,
    openSnackbar,
  };
};

export const showListOfVideoMainTopics = (videoMainTopicArray) => {
  return {
    type: actionTypes.SHOW_VIDEO_MAIN_TOPICS,
    videoMainTopicArray: videoMainTopicArray,
  };
};

export const getListOfVideosInTopic = (
  videosRequestBody,
  success = () => {
  },
  showError = () => {
  },
) => {
  return {
    type: actionTypes.GET_VIDEOS,
    videosRequestBody: videosRequestBody,
    success,
    showError,
  };
};

export const showListOfVideoInTopic = (videosArray) => {
  return {
    type: actionTypes.SHOW_VIDEOS,
    videosArray: videosArray,
  };
};
